//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
    headerText: {
        textAlign: "left",
        font: "normal normal normal 1.5vw Segoe-ui",
        marginBottom: 0,
        letterSpacing: "0px",
        color: " #707070",
        fontSize: 28,
        display: "block",
        textAlign: "center",
    },
    topGrid: {
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
    },
    searchInput: {
        width: "90%",
        borderRadius: 20,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
    badge: {
        backgroundColor: "#C52025",
        color: "#fff",
        fontWeight: "bold",
        position: "relative",
    },
    filterBtn: {
        marginLeft: 20,
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    filterCardDiv: {
        "@media (max-width: 600px)": {
            overflow: "scroll",
        },
    },
    filterCard: {
        boxShadow: " 10px 10px 10px #00000029 !important",
        border: " 1px solid #707070",
        borderRadius: "20px !important",
        width: "100%",
        zIndex: 100,
        marginBottom: 20,
    },
    filterCardGridContainer: {
        // height: "100%",
    },
    filterCardGrid: {
        borderRight: "1px solid #0000004D",
        alignSelf: "center",
    },
    filterCardHeadText: {
        fontWeight: "bold",
        fontSize: 24,
    },
    filterCardSubHeadText: {
        fontSize: 24,
    },
    filterCardInput: {
        borderRadius: 10,
    },
    filterCardBtnGrid: {
        textAlign: "center",
        alignSelf: "center",
    },
    filterCardResetBtn: {
        color: "#305698",
        backgroundColor: "#fff",
        fontSize: 15,
        border: " 1px solid #305698",
        borderRadius: 10,
        width: 100,
        height: 35,
        textTransform: "capitalize",
        marginLeft: "10px",
    },
    filterCardApplyBtn: {
        color: "#fff",
        backgroundColor: "#305698 !important",
        fontSize: 15,
        border: " 1px solid #2F7CBD",
        borderRadius: 10,
        width: 100,
        height: 35,
        textTransform: "capitalize",
        "&:hover": {
            backgroundColor: "#305698 !important",
        },
    },
    tableDiv: {
        marginTop: 20,
    },
    emptyDataText: {
        textAlign: "center",
        fontSize: 30,
        fontFamily: "segoe-ui",
        padding: "10%",
        opacity: "0.4",
    },
    // View Transaction Styles
    editBtn: {
        color: "#fff",
        backgroundColor: "#305698 !important",
        fontSize: 15,
        border: " 1px solid #2F7CBD",
        borderRadius: 10,
        width: 100,
        textTransform: "capitalize",
        "&:hover": {
            backgroundColor: "#305698 !important",
        },
    },
    editCancelBtn: {
        color: "#305698",
        backgroundColor: "#fff",
        fontSize: 15,
        border: " 1px solid #305698",
        borderRadius: 10,
        width: 100,
        height: 35,
        textTransform: "capitalize",
        margin: "5px 0px",
    },
    firstDiv: {
        width: "100%",
        height: 40,
        backgroundColor: "#E4E4E4",
        marginTop: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    secondDiv: {
        color: "#707070",
        fontSize: "1.25rem",
        fontWeight: "bold",
        marginLeft: 10,
    },
    type: {
        color: "#707070",
        fontSize: "0.875rem",
        fontWeight: "bold",
        marginRight: 10,
        "@media (max-width: 768px)": {
            fontSize: 12,
        }
    },
    grid: {
        padding: 10,
        fontSize: "1rem",
        alignSelf: "center",
    },
    gridSpan: {
        fontWeight: "bold",
    },
    processed: {
        color: "green"
    },
    headingText2: {
        marginTop: 25,
        fontSize: "1.125rem",
        marginBottom: 10,
        fontFamily: "segoe-ui",
        "@media (max-width: 768px)": {
            padding: 10,
        },
    },
    tableGrid: {
        marginBottom: "150px",
    },
    RemoveRedEyeIcon: {
        cursor: "pointer",
    },
    gridContainer: {
        padding: 10
    },
    gridItem: {
        textAlign: "right",
        position: "absolute",
        right: "5%",
        marginTop: "60px"
    },
    promotionalSpan: {
        fontWeight: "bold",
        verticalAlign: "Sub"
    },
    cssTextField: {
        width: 200,
    },
    exportParentDiv: {
        color: "#fff",
        cursor: "pointer",
    },
    searchInputIcon: {
        cursor: "pointer",
    }
}));